module.exports = __webpack_public_path__ + "static/img/ph-barnner.318ad909.jpg";